angular.module('zc.projects')

.controller 'ClearanceItemSetUploadCtrl', ($scope, $stateParams, ClearanceItemSet) ->
  clear = ->
    $scope.clearance_item_set =
      name: ''
      description: ''
  clear()

  $scope.$on 'flow::fileAdded', (event, $flow, flowFile) ->
    event.preventDefault()

    ClearanceItemSet.create
      projectId: $stateParams.projectId
    ,
      name: $scope.clearance_item_set.name
      description: $scope.clearance_item_set.description
      file: flowFile.file
    .then (clearance_item_set) ->
      $scope.$parent.project.clearance_item_sets.push clearance_item_set
      clear()



// WEBPACK FOOTER //
// ./src/zenclerk_modules/projects/controllers/clearance_item_set_upload.controller.coffee